import Head from 'next/head';
import MyZoneWithFavs from './MyZoneWithFavs';
import MyZoneEmptyState from './MyZoneEmptyState';

const MyZoneContentWrapper = (props) => {
  const {
    itemsData = [],
    tabData = {},
    locale,
    CompToUse,
    isMobile,
    itemType,
    globalPageConfig,
  } = props;

  const {
    name,
    displayName,
    slug,
    pageTitle,
    viewType,
    metaDescription,
    tags,
    helloPrefixText,
    yourItemsHelpText,
    emptyStateHelpText,
    emptyStateImageUrl,
    emptyStateImageAltText,
    browseAllText,
    browseAllUrl,
    browseAllTags,
  } = tabData;

  const EmptyState = () => {
    return (
      <MyZoneEmptyState
        slug={slug}
        itemType={itemType}
        emptyStateHelpText={emptyStateHelpText}
        emptyStateImageUrl={emptyStateImageUrl}
        emptyStateImageAltText={emptyStateImageAltText}
        browseAllText={browseAllText}
        browseAllUrl={browseAllUrl}
        browseAllTags={browseAllTags}
        isMobile={isMobile}
        locale={locale} />
    );
  };

  const FilledState = () => {
    return (
      <MyZoneWithFavs
        {...props}
        slug={slug}
        tags={tags}
        CompToUse={CompToUse}
        viewType={viewType}
        locale={locale}
        helloPrefixText={helloPrefixText}
        yourItemsHelpText={yourItemsHelpText}
        isMobile={isMobile} />
    );
  };

  const viewToRender = itemsData.length > 0
    ? <FilledState />
    : <EmptyState />;

  const metaDescriptionToUse = metaDescription || (globalPageConfig && globalPageConfig.defaultMetaDescription);
  const pageTitleBase = globalPageConfig && globalPageConfig.pageTitleBase ? globalPageConfig.pageTitleBase : '';
  const pageTitleToUse = `${pageTitle} ${pageTitleBase}`;

  return (
    <div>
      <Head>
        <title>{pageTitleToUse}</title>
        <meta name="description" content={metaDescriptionToUse} />
      </Head>

      {viewToRender}
    </div>
  );
};

export default MyZoneContentWrapper;
